import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaEventService } from '../../../services/ga-event.service';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { LovService } from '../../../services/lov.service';
import { FormattingService } from '../../../services/formatting.service';
import { ILov } from '../../../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { TranslationService } from '../../../translation/translation.service';
import { BPProfilesOEMUtilService } from '../../../bp-profiles/bp-profiles-oem-util.service';
import { Override } from '../../../app-decorators';
import { ROW_TIER_STATUS } from '../preconditions/oem-tier-status-precondition.service';
import { util } from '../../../util';

@Component({
  selector: 'set-oem-processing-shipping-mode-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class SetOEMProcessingShippingModeActionComponent extends BaseReportActionsDialog implements OnInit {
  private processingModeField: IExtraFieldConfigurationObject;
  private shippingFlowField: IExtraFieldConfigurationObject;

  private selectedTierStatus: string;

  constructor(
    private formlyService: GaFormlyService,
    private lovService: LovService,
    private formattingService: FormattingService,
    private bpProfilesOemUtilService: BPProfilesOEMUtilService,
    protected translationService: TranslationService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  @Override(BaseReportActionsDialog)
  public ngOnInit(): void {
    this.saveButtonLabel = this.translationService.instant('GA.BUTTONS.SAVE');
    super.ngOnInit();

    this.selectedTierStatus = util.extractValue(Object.values(this.rowSelection)[0]?.[ROW_TIER_STATUS]);
    this.fields = this.createFields();

    // fill fields
    this.fillFields();
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    const labelClass: string = 'col-sm-4';
    const valueClass: string = 'col-sm-8';

    return [
      this.processingModeField = this.formlyService.aRadio('processingMode', 'Default processing mode')
        .isRequired()
        .withLabelClass(labelClass)
        .withValueClass(valueClass)
        .withWrapperClass('radio-horizontal')
        .withFormat(this.formattingService.formatLov)
        .onChange(this.onProcessingModeChange)
        .build(),

      this.shippingFlowField = this.formlyService.aRadio('shippingFlow', 'Shipping flow')
        .isRequired()
        .withLabelClass(labelClass)
        .withValueClass(valueClass)
        .withWrapperClass('radio-horizontal')
        .withFormat(this.formattingService.formatLov)
        .withHideExpression(() => _.isUndefined(this.model?.processingMode))
        .build()
    ];
  }

  private fillFields(): void {
    this.formlyService.fillField(
      this.processingModeField,
      this.lovService.list('DOPLATO')
        .then(this.filterProcessingModes)
    );
  }

  private onProcessingModeChange = (): void => {
    if (!_.isUndefined(this.model?.processingMode)) {
      this.formlyService.fillField(
        this.shippingFlowField,
        this.lovService.list('DOSHPCU')
          .then(this.filterShippingFlows)
      );
    }
  };

  private filterProcessingModes = (processModes: ILov[]): ILov[] => {
    return this.bpProfilesOemUtilService.filterProcessingModes(processModes, (this.selectedTierStatus === 'Distributor'));
  };

  private filterShippingFlows = (shippingFlows: ILov[]): ILov[] => {
    return this.bpProfilesOemUtilService.filterShippingFlows(shippingFlows, this.model?.processingMode?.id);
  };
}